import { createServerFn, ClientSafeError } from "catmint/server";

/**
 * Throws a ClientSafeError — the message, statusCode, and data are
 * intentionally sent to the client.
 */
export const throwClientSafeError = createServerFn(async () => {
  throw new ClientSafeError("Insufficient funds", {
    statusCode: 422,
    data: { available: 50, requested: 100 },
  });
});

/**
 * Returns a ClientSafeError instead of throwing it.
 * The client receives a ServerFnError as the return value (not thrown).
 */
export const returnClientSafeError = createServerFn(async () => {
  return new ClientSafeError("Payment method expired", {
    statusCode: 402,
    data: { expiredAt: "2025-01-15" },
  });
});

/**
 * Throws a plain Error — the real message is never sent to the client.
 * In dev the client sees "[DEV ONLY] ...", in prod "Internal Server Error [ref: ...]".
 */
export const throwUnsafeError = createServerFn(async () => {
  throw new Error(
    "Connection refused: postgres://admin:s3cret@10.0.0.5:5432/prod",
  );
});
